/*
 * Ballr — kit layouts.
 *
 * One entry per poster family, carrying the measured geometry so a new product
 * only has to say which family it belongs to. Nothing here is per-product.
 * Adding a new poster range means adding one entry.
 */
window.BallrKitLayouts = {
  "fullbleed": {
    "label": "Full-bleed jersey poster",
    "quad": [
      [
        0.1767,
        0.0689
      ],
      [
        0.7844,
        0.0689
      ],
      [
        0.7844,
        0.9133
      ],
      [
        0.1767,
        0.9133
      ]
    ],
    "aspect": 1.3895,
    "erase": [
      [
        0.24,
        0.165,
        0.76,
        0.7
      ]
    ],
    "fields": [
      {
        "key": "name",
        "label": "Name on kit",
        "property": "Add Your Name",
        "type": "text",
        "max": 12,
        "placeholder": "YOUR NAME",
        "hint": "Up to 12 letters \u2014 printed exactly as typed",
        "draw": {
          "cx": 0.503,
          "cy": 0.2385,
          "h": 0.1302,
          "maxW": 0.82,
          "tracking": 0.03,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "number",
        "label": "Number",
        "property": "Add Your Kit Number",
        "type": "number",
        "max": 2,
        "placeholder": "10",
        "draw": {
          "cx": 0.5006,
          "cy": 0.54,
          "h": 0.3583,
          "maxW": 0.66,
          "tracking": 0.0,
          "color": "#FFFFFF"
        }
      }
    ]
  },
  "locker2": {
    "label": "Locker room \u2014 two shirts",
    "quad": [
      [
        0.245,
        0.1325
      ],
      [
        0.737,
        0.1325
      ],
      [
        0.7545,
        0.8395
      ],
      [
        0.24,
        0.8395
      ]
    ],
    "aspect": 1.437,
    "erase": [
      [
        0.16,
        0.39,
        0.41,
        0.662
      ],
      [
        0.596,
        0.39,
        0.846,
        0.662
      ]
    ],
    "fields": [
      {
        "key": "name",
        "label": "Name on kit",
        "property": "Add Your Name",
        "type": "text",
        "max": 12,
        "placeholder": "YOUR NAME",
        "hint": "Up to 12 letters",
        "draw": {
          "cx": 0.282,
          "cy": 0.4385,
          "h": 0.046,
          "maxW": 0.21,
          "tracking": 0.02,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "number",
        "label": "Number",
        "property": "Add Your Kit Number",
        "type": "number",
        "max": 2,
        "placeholder": "10",
        "draw": {
          "cx": 0.285,
          "cy": 0.5495,
          "h": 0.124,
          "maxW": 0.21,
          "tracking": 0.0,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "player_name",
        "label": "Second name",
        "property": "Add Player Name",
        "type": "text",
        "max": 12,
        "placeholder": "SECOND NAME",
        "hint": "Up to 12 letters",
        "draw": {
          "cx": 0.718,
          "cy": 0.4385,
          "h": 0.046,
          "maxW": 0.21,
          "tracking": 0.02,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "player_number",
        "label": "Number",
        "property": "Add Player Kit Number",
        "type": "number",
        "max": 2,
        "placeholder": "10",
        "draw": {
          "cx": 0.72,
          "cy": 0.5495,
          "h": 0.124,
          "maxW": 0.21,
          "tracking": 0.0,
          "color": "#FFFFFF"
        }
      }
    ]
  },
  "card1": {
    "label": "Locker room card \u2014 one shirt",
    "quad": [
      [
        0.245,
        0.1325
      ],
      [
        0.737,
        0.1325
      ],
      [
        0.7545,
        0.8395
      ],
      [
        0.24,
        0.8395
      ]
    ],
    "aspect": 1.437,
    "erase": [
      [
        0.39,
        0.408,
        0.626,
        0.652
      ]
    ],
    "fields": [
      {
        "key": "name",
        "label": "Name on kit",
        "property": "Add Your Name",
        "type": "text",
        "max": 12,
        "placeholder": "YOUR NAME",
        "hint": "Up to 12 letters",
        "draw": {
          "cx": 0.502,
          "cy": 0.4535,
          "h": 0.038,
          "maxW": 0.205,
          "tracking": 0.02,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "number",
        "label": "Number",
        "property": "Add Your Kit Number",
        "type": "number",
        "max": 2,
        "placeholder": "10",
        "draw": {
          "cx": 0.5105,
          "cy": 0.544,
          "h": 0.122,
          "maxW": 0.205,
          "tracking": 0.0,
          "color": "#FFFFFF"
        }
      }
    ]
  },
  "couples": {
    "label": "Couples \u2014 two shirts + subtitle",
    "quad": [
      [
        0.1504,
        0.3675
      ],
      [
        0.7635,
        0.371
      ],
      [
        0.7425,
        0.8696
      ],
      [
        0.1474,
        0.8696
      ]
    ],
    "aspect": 0.7105,
    "erase": [
      [
        0.214,
        0.246,
        0.412,
        0.622
      ],
      [
        0.606,
        0.246,
        0.804,
        0.622
      ],
      [
        0.045,
        0.896,
        0.97,
        0.97,
        "fill"
      ]
    ],
    "fields": [
      {
        "key": "name",
        "label": "Your name",
        "property": "Add Your Name",
        "type": "text",
        "max": 12,
        "placeholder": "YOUR NAME",
        "hint": "Up to 12 letters",
        "draw": {
          "cx": 0.3115,
          "cy": 0.315,
          "h": 0.06,
          "maxW": 0.2,
          "tracking": 0.02,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "number",
        "label": "Number",
        "property": "Add Your Kit Number",
        "type": "number",
        "max": 2,
        "placeholder": "10",
        "draw": {
          "cx": 0.3215,
          "cy": 0.484,
          "h": 0.212,
          "maxW": 0.19,
          "tracking": 0.0,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "couple_name",
        "label": "Partner name",
        "property": "Add Your Couple Name",
        "type": "text",
        "max": 12,
        "placeholder": "PARTNER",
        "hint": "Up to 12 letters",
        "draw": {
          "cx": 0.7035,
          "cy": 0.315,
          "h": 0.06,
          "maxW": 0.2,
          "tracking": 0.02,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "couple_number",
        "label": "Number",
        "property": "Add Your Couple Kit Number",
        "type": "number",
        "max": 2,
        "placeholder": "10",
        "draw": {
          "cx": 0.7155,
          "cy": 0.484,
          "h": 0.212,
          "maxW": 0.19,
          "tracking": 0.0,
          "color": "#FFFFFF"
        }
      },
      {
        "key": "subtitle",
        "label": "Subtitle",
        "property": "Add Your Subtitle",
        "type": "long",
        "max": 30,
        "placeholder": "EST. 2024",
        "hint": "Shown under the kits",
        "draw": {
          "cx": 0.5,
          "cy": 0.935,
          "h": 0.038,
          "maxW": 0.86,
          "tracking": 0.0,
          "color": "#FFFFFF"
        }
      }
    ]
  }
};
